String.prototype.toHtmlEntities = function () {
  return this.replace(/./gm, function (s) {
    return (s.match(/[a-z0-9\s]+/i)) ? s : "&#" + s.charCodeAt(0) + ";";
  });
};
